import { createRootRoute, Outlet } from '@tanstack/react-router'
import { t } from '../lib/i18n'

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="grid h-full place-items-center p-6 text-center">
      <div>
        <p className="text-2xs font-semibold uppercase tracking-wider text-ink-3">404</p>
        <h1 className="mt-1 font-display text-xl">{t('Página não encontrada')}</h1>
        <a href="/" className="mt-3 inline-block text-sm text-accent underline underline-offset-4">
          {t('Voltar ao início')}
        </a>
      </div>
    </div>
  ),
})
